/**
 * LOGIN PAGE API CALLS
 *
 * @version 0.1
 */
import React  from 'react';
import reduxStore from './../../reduxStore';
import xhr from './../../utils/xhr';

import {
    SET_HELP_URL_ROOT,
    USER_INFO_SUCCESS,
    UPDATE_USER_PREFERENCES
} from './../Main/Main.reducers';

var api = {

    getHelpUrlRoot: function() {
        return xhr.get({
            url: '/login/helpUrlRoot'
        }).then((response) => {
            reduxStore.dispatch({
                type:    SET_HELP_URL_ROOT,
                payload: response.text
            });
        }).then(() => xhr.get({url: '/login/version'})
            .then((response) => {
                reduxStore.dispatch({
                    type:    "SET_VERSION",
                    payload: response.text
                });

            return response;
        })).then(() => xhr.get({url: '/login/settings'})
            .then((response)=>{
                reduxStore.dispatch({
                    type:    "USER_AUTHENTICATION_TYPE",
                    payload: response.body
                });

            }));
    },

    getUserInfo: function() {

        return xhr.get({
            url:    '/api/user.json'
        }).then((response) => {

            // Successfully fetched user data and present the start screen (either Batch Upload or Dashboard)
            reduxStore.dispatch(
                {
                    type:    USER_INFO_SUCCESS,
                    payload: response.body
                }
            );
            reduxStore.dispatch({
                type:    "EXPERIAN_FLAG",
                payload: response.body.experianEnabled
            });

        });
    },

    updateUserPrefs: function(prefs) {
        reduxStore.dispatch({
            type:    UPDATE_USER_PREFERENCES,
            payload: prefs
        });

        return xhr.put({
            url:    '/api/user',
            data: reduxStore.getState().user.preferences
        }).catch((error) => {
            console.log("********************** Failed to update user prefs ********************");
            xhr.handleAllErrors(error);
        });

    },

    loginWam: function(searchParam){
        return xhr.get({
            url: '/login/wam/' + searchParam});
    }

};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/pages/LoginPage/LoginPage.api.js